import { extend } from 'flarum/common/extend';
import classList from 'flarum/common/utils/classList';

import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';

export default function addStickyClass() {
  extend(DiscussionListItem.prototype, 'elementAttrs', function (attrs) {
    let tagItem = sessionStorage.getItem('tagItem');
    const tag = app.store.getBy('tags', 'slug', tagItem);
    let isAllTag = tag && tag.isAllTag();
    let isSticky = isAllTag ? this.attrs.discussion.isAllSticky() : this.attrs.discussion.isSticky()
    if (isSticky) {
      attrs.className = classList(attrs.className, 'DiscussionListItem--sticky');
    }
  });
}
